import React from 'react';
import Cookies from 'js-cookie';
import DashBoardNavBar from '../components/DashBoardNavBar.tsx';
import Navbar from '../components/Navbar.tsx';
import { Particles } from '../components/Particles.tsx';
import { Container, Typography, Box, Paper, useTheme, Divider, Link } from '@mui/material';

const TermsOfService: React.FC = () => {
  const isAuthenticated = !!Cookies.get('token');
  const theme = useTheme();
  const darkMode = theme.palette.mode === 'dark';

  return (
    <Box sx={{ position: 'relative', height: '100vh', width: '100vw', overflowX: 'hidden', overflowY: 'auto', display: 'flex', flexDirection: 'column' }}>
      <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: -1, position: 'fixed' }}>
        <Particles />
      </div>
      {isAuthenticated ? <DashBoardNavBar /> : <Navbar />}

      <Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'flex-start', justifyContent: 'center', pt: { xs: '90px', md: '100px' }, pb: 4 }}>
        <Container maxWidth="md">
          <Paper sx={{ p: { xs: 3, md: 5 }, borderRadius: '24px', background: darkMode ? 'rgba(0,0,0,0.6)' : 'rgba(255,255,255,0.8)', backdropFilter: 'blur(10px)', border: darkMode ? '1px solid rgba(255,255,255,0.1)' : '1px solid rgba(0,0,0,0.05)', color: darkMode ? 'rgba(255,255,255,0.85)' : '#333' }}>
            <Typography variant="h3" component="h1" gutterBottom sx={{ fontWeight: 'bold', color: darkMode ? 'white' : '#1a237e', textAlign: 'center' }}>
              Terms of Service
            </Typography>
            <Typography variant="subtitle1" sx={{ textAlign: 'center', mb: 4, opacity: 0.7 }}>
              Last updated: April 2026
            </Typography>
            <Divider sx={{ mb: 4, borderColor: darkMode ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)' }} />

            <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold', color: darkMode ? 'white' : '#1a237e', mt: 3 }}>1. Introduction</Typography>
            <Typography variant="body1" paragraph>
              Welcome to LinkLearning (<Link href="https://linklearning.net/" target="_blank" color="inherit">https://linklearning.net/</Link>). By accessing or using our website, services, and platform, you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our platform.
            </Typography>

            <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold', color: darkMode ? 'white' : '#1a237e', mt: 3 }}>2. User Obligations</Typography>
            <Typography variant="body1" paragraph>
              To access certain features of LinkLearning, you must register for an account. You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account. You agree not to use the platform for any unlawful purpose, to distribute spam, or to attempt to disrupt or compromise the integrity and security of our systems.
            </Typography>

            <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold', color: darkMode ? 'white' : '#1a237e', mt: 3 }}>3. Intellectual Property</Typography>
            <Typography variant="body1" paragraph>
              The platform, including its original content, features, and functionality, are owned by LinkLearning and are protected by international copyright, trademark, and other intellectual property laws. You may not reproduce, distribute, or create derivative works from any part of our platform without explicit permission.
            </Typography>
            
            <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold', color: darkMode ? 'white' : '#1a237e', mt: 3 }}>4. Limitation of Liability</Typography>
            <Typography variant="body1" paragraph>
              LinkLearning is provided on an "as is" and "as available" basis. In no event shall LinkLearning, nor its developers or partners, be liable for any indirect, incidental, special, consequential, or punitive damages arising out of your access to, use of, or inability to use the platform.
            </Typography>

            <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold', color: darkMode ? 'white' : '#1a237e', mt: 3 }}>5. Contact Us</Typography>
            <Typography variant="body1" paragraph>
              If you have any questions about these Terms, please contact us at <strong>official.linklearning@gmail.com</strong>.
            </Typography>

          </Paper>
        </Container>
      </Box>
    </Box>
  );
};

export default TermsOfService;